
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-accb890a!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Books.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Books.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-accb890a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Books.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/share/Books.vue
// module id = 627
// module chunks = 1